// Misc
import React, { Children, Component, cloneElement, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import scrollIntoView from 'scroll-into-view'
import compact from 'lodash/compact'
import debounce from 'lodash/debounce'
import isArray from 'lodash/isArray'

// Styles
const styles = {
  children: {
    paddingTop: '50vh',
    paddingBottom: '50vh',
  },
  sectionWrapper: {
    '&:not(:last-child)': {
      marginBottom: '25vh',
    }
  },
}

export default
@withStyles(styles)
class ScrollContainer extends Component {
  static propTypes = {
    children: PropTypes.any,
    classes: PropTypes.object.isRequired,
    defaultActiveSectionIndex: PropTypes.number,
  }

  static defaultProps = {
    defaultActiveSectionIndex: 0,
  }

  topOffset = 0

  sectionNodes = []

  constructor({ defaultActiveSectionIndex }) {
    super()
    this.state = {
      activeSectionIndex: defaultActiveSectionIndex,
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)

    const { activeSectionIndex } = this.state
    this.screenCenter = this.findCenterOfScreen()
    setImmediate(() => {
      this.activateSection(activeSectionIndex)
    })
  }

  componentDidUpdate() {
    this.updateActiveSectionIndex()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  }

  findCenterOfScreen = () => {
    return window.innerHeight / 2
  }

  updateActiveSectionIndex = debounce(() => { // eslint-disable-line
    const { activeSectionIndex: prevActiveSectionIndex } = this.state
    let activeSectionIndex = 0

    while (
      activeSectionIndex + 1 < this.sectionNodes.length
      && this.sectionNodes[activeSectionIndex + 1].getBoundingClientRect().top < this.screenCenter
    ) {
      activeSectionIndex += 1
    }

    if (activeSectionIndex !== prevActiveSectionIndex) {
      this.setState({ activeSectionIndex })
    }
  }, 50)

  activateSection = (index, params = {}) => {
    if (this.sectionNodes[index]) {
      scrollIntoView(this.sectionNodes[index], params)
    }
  }

  handleScroll = () => {
    this.updateActiveSectionIndex()
  }

  handleResize = () => {
    this.screenCenter = this.findCenterOfScreen()
    this.updateActiveSectionIndex()
  }

  sectionNodeRef(node, index) {
    if (node) {
      this.sectionNodes[index] = node
    } else {
      this.sectionNodes.splice(index, 1)
    }
  }

  renderChildren() {
    const { children: initialChildren, classes } = this.props
    const { activeSectionIndex } = this.state
    const children = compact(isArray(initialChildren) ? initialChildren : [initialChildren])
    return Children.map(children, (child, index) => (
      <div className={classes.sectionWrapper}>
        { cloneElement(child, {
          index,
          isActive: index === activeSectionIndex,
          onSectionActivate: this.activateSection,
          nodeRef: node => this.sectionNodeRef(node, index),
        }) }
      </div>
    ))
  }

  render() {
    const { classes } = this.props
    return (
      <Fragment>
        <div ref={this.offsetMeterRef} className={classes.offsetMeter} />
        <div className={classes.children}>
          { this.renderChildren() }
        </div>
      </Fragment>
    )
  }
}
